import * as THREE from "three";
import Experience from "../Experience.js";

export default class LightSwitch {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.debug = this.experience.debug;

    // Debug
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("LightSwitch");
    }

    // Resource
    this.resource = this.resources.items.lightswitchModel;

    this.setModel();
  }

  setModel() {
    this.model = this.resource.scene;
    this.model.position.set(-2.72, 0.1, 0.25);
    this.model.rotateZ(Math.PI * 0.5);
    this.model.rotateY(Math.PI * 0.5);
    this.scene.add(this.model);
    this.model.name = "lightswitch";

    this.model.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.name = this.model.name;
      }
    });
  }
}
